export default __webpack_public_path__ + "static/media/magze_fa.d6bebc1a.svg";